import React, { createElement } from 'react'
import { Copy, CopyCheck, Edit } from 'lucide-react'

import { Field } from 'src/pages/ServiceContacts/types'
import { useInfoContactWindow } from 'src/features/InfoContactWindow/useInfoContactWindow'
import {
  FieldId,
  InfoContactWindowProps,
} from 'src/features/InfoContactWindow/types'
import {
  ICON_SIZE,
  ICON_STROKE_WIDTH,
} from 'src/features/InfoContactWindow/constants'
import { ScrollArea } from 'src/components/shadcn/scroll-area'
import { Button } from 'src/components/shadcn/button'
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from 'src/components/shadcn/alert-dialog'

export const InfoContactWindow = ({
  contact,
  toggle,
  isOpen,
  toggleEditMode,
}: InfoContactWindowProps) => {
  const {
    listOfFields,
    title,
    close,
    handleCopy,
    serviceTypeDictionary,
    copied,
    handleClick,
  } = useInfoContactWindow({ toggle, toggleEditMode })

  return (
    <form>
      <AlertDialog open={isOpen}>
        <AlertDialogContent className="max-h-[100svh] overflow-y-auto">
          <AlertDialogHeader>
            <AlertDialogTitle className="text-center mb-2">
              {title}
            </AlertDialogTitle>
          </AlertDialogHeader>
          <AlertDialogDescription>
            <ScrollArea className="h-[80svh] md:h-[65svh] w-full">
              <div className="space-y-4">
                {listOfFields.map((field: Field) =>
                  !contact?.additionalNotes &&
                  field.id === FieldId.AdditionalNotes ? null : (
                    <div key={field.id}>
                      <div className="flex gap-2">
                        <div className="pt-2 font-medium text-gray-900 dark:text-gray-100">
                          {field.icon &&
                            createElement(field.icon, {
                              size: ICON_SIZE,
                              strokeWidth: ICON_STROKE_WIDTH,
                            })}
                        </div>
                        <h1 className="text-lg pt-1 font-medium text-gray-900 dark:text-gray-100">
                          {field.label}
                        </h1>
                      </div>
                      <div className="flex gap-2 whitespace-normal break-words max-w-xs text-base text-gray-600 dark:text-gray-400">
                        <p className="w-3/4 break-words pt-2">
                          {field.id === FieldId.ServiceType
                            ? serviceTypeDictionary[contact?.serviceType] || ''
                            : contact?.[field.id]}
                        </p>
                        <Button
                          variant="ghost"
                          className="rounded-[10px]"
                          onClick={() =>
                            handleCopy(
                              field.id === FieldId.ServiceType
                                ? serviceTypeDictionary[contact?.serviceType] ||
                                    ''
                                : String(contact[field.id]),
                            )
                          }
                        >
                          {copied === contact[field.id] ? (
                            <CopyCheck className="text-green-500" />
                          ) : (
                            <Copy />
                          )}
                        </Button>
                      </div>
                    </div>
                  ),
                )}
              </div>
            </ScrollArea>
          </AlertDialogDescription>
          <AlertDialogFooter>
            <Button
              variant="outline"
              className="text-gray-500 hover:text-blue-500 rounded-[10px]"
              onClick={() => handleClick(contact.id)}
            >
              <Edit size={ICON_SIZE} />
            </Button>
            <AlertDialogCancel
              className="rounded-[10px]"
              type="button"
              onClick={toggle}
            >
              {close}
            </AlertDialogCancel>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </form>
  )
}
